<div class="sidebar" [hidden]="sharedService.editorFullScreen" (clickOutside)="onClickedOutsideSideBar()" [exclude]="'.mobile-sidebar-toggler'">
    <div class="top">
        <ng-container *ngFor="let item of sharedService.sidebarItems">
            <div
                class="sidebar-item"
                (click)="toggleSideBarItem(item, p)"
                [ngClass]="{ active: item.isOpen, 'active-mobile': item.isOpenMobile }"
                [routerLinkActive]="'active-child'"
                [routerLinkActiveOptions]="{ exact: true }"
                [ngbPopover]="popFlyout"
                triggers="manual"
                #p="ngbPopover"
                container="body"
                placement="right-top"
                popoverClass="sidebar-pop"
                [autoClose]="'outside'"
            >
                <div class="content">
                    <i [ngClass]="item.icon"></i>
                    <span> {{ item.name }} </span>
                </div>

                <i class="far icon" [ngClass]="{ 'fa-angle-right': !item.isOpen, 'fa-angle-down': item.isOpen }"></i>

                <ng-template #popFlyout>
                    <div class="sidebar-item-flyout" (clickOutside)="onClickedOutside()" [exclude]="'.sidebar-item'">
                        <div class="head">
                            {{ item.name }}
                        </div>
                        <div class="list">
                            <a
                                class="list-item"
                                *ngFor="let subItem of item.items"
                                [routerLink]="[subItem.link]"
                                [routerLinkActive]="'active'"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="closeAllPops(p)"
                            >
                                {{ subItem.name }}
                            </a>
                        </div>
                    </div>
                </ng-template>
            </div>
            <ng-container *ngIf="item.isOpen">
                <a
                    (click)="sharedService.mp3SielnceNotification()"
                    class="sidebar-subitem"
                    *ngFor="let subItem of item.items"
                    [routerLink]="[subItem.link]"
                    [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                    <span> {{ subItem.name }} </span>
                </a>
            </ng-container>
        </ng-container>
    </div>
    <div class="bottom">
        <button (click)="toggleSideBar()">
            <i class="fal fa-angle-double-left"></i>
        </button>
    </div>
</div>
